module.exports = {
  title: "AI 시대 개발자 도구 블로그 | JavaPark",
  description: "AI 시대의 개발자 도구, 실전 경험을 공유합니다",
  author: "JavaPark",
  authorProfile: {
    alternateName: "자바파커",
    jobTitle: "개발자 / 블로거",
    description:
      "AI 시대의 개발자 도구와 실전 활용법을 연구하고 공유하는 자바파커입니다.",
    knowsAbout: [
      "AI 개발자 도구",
      "Claude Code",
      "Kubernetes",
      "DevOps",
      "GitHub Pages",
      "Next.js",
      "Python",
    ],
  },
  siteUrl: "https://blog.javapark.kr",
  links: {
    github: "https://github.com/javapark",
    email: "mailto:javaparknet@gmail.com",
  },
  giscus: {
    repo: "javapark/javapark.github.io",
    repoId: "R_kgDOIT56xw",
    category: "General",
    categoryId: "DIC_kwDOIT56x84C6ByT",
  },
  gtag: "G-TG9BJHTX59",
}
